import React from 'react';
import PropTypes from 'prop-types';

import Option from './option';
import { activityTypes } from 'bundles/apex/activities/type/config';

import './styles.scss';

export default function ActivityTypeInput({ activityType, onChange }) {
  return (
    <div>
      <label>Activity Type</label>
      <div className="d-flex mb-4">
        {Object.values(activityTypes).map(({ key }) => (
          <Option
            activityType={key}
            key={key}
            selected={key === activityType}
            onClick={() => onChange({ activityType: key })}
          />
        ))}
      </div>
    </div>
  );
}

ActivityTypeInput.propTypes = {
  activityType: PropTypes.oneOf(Object.keys(activityTypes)).isRequired,
  onChange: PropTypes.func.isRequired,
};
